module.exports = __webpack_public_path__ + "static/about-compressed-83c8783dc3851497b631184b09ed4a7c.mp4";